//$Id$
/**
 * @file security-util
 * @version 1.0.0
 * @summary  It contains security related common functions
 * @dependency client-storage zprojects/asset/utils/client-storage.js
 * @notes ZSEC.Encoder.encodeForHTML - Use this function to render string as html tag, if input contains xss
 * ZSEC.Encoder.encodeForHTMLAttribute - Use this function to sanitaize string in html attribute value
 * ZSEC.URLValidator.sanitize - Use this function to sanitaize URL
 * ZSEC.Encoder.encodeForJavaScript - Use this function if user input contains xss and using it in js variable
 * Deprecated Functions - htmlEncode, reverseXSSEscape, getCSRFEncode, htmlUnEscape, htmlUnescapeAll, htmlDecode, sanitizeHtml
 */

const ZPSecurity = {
    decodeForHTML : function(value) { // Decodes HTML-encoded values
        if (value == null) return '';
        const textarea = document.createElement('textarea');
        textarea.innerHTML = value;
        return textarea.value;
    }
}

/**
 * Encode these special charecters /[&<>"'] when concatenate string with html
 * @deprecated
 * @param {string} str string contains special charecters
 * @returns {string} returns encoded html string
 */ 
function htmlEncode(str) {
    return str.replace(/[&<>"']/g, function($0) {
        return "&" + {"&":"amp", "<":"lt", ">":"gt", '"':"quot", "'":"#39"}[$0] + ";";//No I18N
    });
}

/**
 * Reverse XSS Escape value, which is XSS Escaped when stored value in DB. Use it for existing data only.
 * @deprecated 
 * @param {string} str XSS Escaped value
 * @returns {string} Reverse XSS Escaped value
 * @notes As per security team, user data shouldn't modified for xss escape and store it in db. So store it as directly in db and XSS Escape only in rendering  
 */ 
function reverseXSSEscape(str){
	return  str &&  str.replace(/&(amp|lt|gt|quot|#39);/g, function($0) {
	        return {"&amp;":"&", "&lt;":"<", "&gt;":">", '&quot;':'"', "&#39;":"'"}[$0];//No I18N
	    });
}

//Misconfiguration at different endpoints with xss escape at one endpoint and normal type as another endpoint

function misConfDecodeAndEncodeCallback(callback, value){
	if(typeof callback == 'function' && value){
		value = reverseXSSEscape(value);
		return callback(value);
	}
}

/**
 * Encode HTML string which is xss escaped from our product and applied zoho security decoder when save
 * @type {function}
 * @param {string} value Previously xss escaped and zoho security encoded value. 
 * @returns {string} returns reverse xss escaped and decoded value
 */ 

function misConfEncodeHTML(value){
	return misConfDecodeAndEncodeCallback(ZSEC.Encoder.encodeForHTML, value);
}

/**
 * Encode JS values which is xss escaped from our product and applied zoho security decoder when save
 * @type {function}
 * @param {string} value Previously xss escaped and zoho security decoder. 
 * @returns {string} returns reverse xss escaped and encoded value
 */
function misConfEncodeJS(value){
	return misConfDecodeAndEncodeCallback(ZSEC.Encoder.encodeForJavaScript, value);
}

/**
 * Encode HTML attributes which is xss escaped from our product and applied zoho security decoder when save
 * @type {function}
 * @param {string} value Previously xss escaped and zoho security decoder. 
 * @returns {string} returns reverse xss escaped and encoded value
 */
function misConfEncodeHTMLAttr(value){
	return misConfDecodeAndEncodeCallback(ZSEC.Encoder.encodeForHTMLAttribute, value);
}

function htmlUnEscape(str)
{
if(str !== undefined && str !== null){
	str = str.replace(/(&amp;amp&#x3b;)/g,"&");//No I18N
	str = str.replace(/&amp;/g,"&");//No I18N
	str = str.replace(/&lt&#x3b;/g,"<");//No I18N
	str = str.replace(/&gt;/g,">");//No I18N
	str = str.replace(/&lt;/g,"<");//No I18N
	str = str.replace(/(&quot&#x3b;)/g,'"');//No I18N
	str = str.replace(/&quot;/g,'"');//No I18N
	str = str.replace(/&#39;/g,"'");//No I18N
	str = str.replace(/&#x2f;/g,"/");//No I18N
	str = str.replace(/&&#x23;39&#x3b;/g,"'");//No I18N
}
return str;
}

function htmlUnescapeAll(s)
{   
    s = s.replace(/<br>/g,"\n"); //no i18n
    s = s.replace(/&lt;/g, "<"); //No I18N
    s = s.replace(/&gt;/g, ">"); //No I18N
    s = s.replace(/&quot;/g, "\""); //No I18N
    s = s.replace(/&#39;/g, "'"); //No I18N
    s = s.replace(/&amp;/g, "&"); //No I18N
    return s;
}

function getCSRFEncode(csrf){
	if(csrf !== undefined){
		var csrfSplit = csrf.split("=");
		return csrfSplit[0]+"="+encodeURIComponent(csrfSplit[1]);
	}
}

function htmlDecode(value) {
	if(typeof value === 'undefined'){
		return '';
	}else{
		let div = document.createElement('div');	//no i18n
		div.innerHTML = value;
  		return div.textContent;
	}
}

function sanitizeHtml(content){
	let domParser = new DOMParser().parseFromString(content, "text/html");	//no i18n
	var sanitizedHtml = domParser.querySelector('body').innerHTML;	//no i18n
	if(sanitizedHtml == null){sanitizedHtml = "";}
	return sanitizedHtml;
}

Object.assign(window, {htmlEncode, reverseXSSEscape, misConfDecodeAndEncodeCallback, misConfEncodeHTML, misConfEncodeJS, misConfEncodeHTMLAttr,
    htmlUnEscape, htmlUnescapeAll, getCSRFEncode, htmlDecode, sanitizeHtml, ZPSecurity});